<template>
    <div v-if="options_loaded && passed_filter">
        <div class="designeroption" :data-designer-component-id="component_id">
            <div class="stylesoption" v-if="!loading" style="display: flex; flex-wrap: wrap;">
                <div class="mr-3" :class="[target == option.value ? 'active' : '']" v-for="option in filtered_option_list">
                    <label>
                        <input type="radio" v-model="localTarget"
                               :name="'radio_' + component_id"
                               :value="option.value"/>
                        {{ option.label }}
                    </label>
                </div>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionCollection from "../DesignerQuestionCollection.vue";

    export default {
        mixins: [
            DesignerQuestionCollection
        ],
        props: {
            title: {
                default(){
                    return 'Panel Type';
                }
            },
            slab: {
                required: true,
            },
            question: {
                required: true,
            }
        },
        computed: {
            url() {
                return '/api/options/' + this.fabricator + '/collection?question=' + this.question + '&slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.question +  '_' + this.slab;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
